import { useState, useEffect, useRef } from "react";
import { SUPABASE_URL, authFetch } from "../lib/supabase";

export function useDetectors({ suite, trades = [], profile = null, rules = [], userId, tradesLoading = false }) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const reqRef = useRef(0);

  const tradesKey = trades.length + "_" + (trades[0]?.id || "") + "_" + (trades[trades.length - 1]?.id || "");

  useEffect(() => {
    if (!userId) {
      setData(null);
      setLoading(false);
      return;
    }

    // Still fetching trades — stay loading
    if (tradesLoading) {
      setLoading(true);
      return;
    }

    // Trades loaded but none for this account/filter
    if (!trades.length) {
      setData(null);
      setLoading(false);
      return;
    }

    const reqId = ++reqRef.current;
    setLoading(true);
    setError(null);

    (async () => {
      try {
        const res = await authFetch(`${SUPABASE_URL}/functions/v1/run-detectors`, {
          method: "POST",
          body: JSON.stringify({ suite, trades, profile, rules }),
        });

        if (reqId !== reqRef.current) return;

        if (res.status === 403) {
          setError("subscription_required");
          setLoading(false);
          return;
        }

        if (!res.ok) {
          const err = await res.json().catch(() => ({ error: "Unknown error" }));
          throw new Error(err.error || `HTTP ${res.status}`);
        }

        const json = await res.json();
        if (reqId !== reqRef.current) return;

        setData(json[suite] || json);
        setError(null);
      } catch (e) {
        if (reqId !== reqRef.current) return;
        setError(e.message);
      } finally {
        if (reqId === reqRef.current) setLoading(false);
      }
    })();
  // tradesLoading in deps ensures effect re-runs when fetch completes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suite, userId, tradesKey, tradesLoading]);

  return { data, loading, error };
}
